import React from "react";
import { Box } from "@mui/material";
import { SaveFormButton } from "../buttons/SaveFormButton";

type FormSaveFooterProps = {
  onSave: () => void;
  label: string;
  /** Guardar deshabilitado: mientras se guarda, un segundo clic no hace nada. */
  disabled?: boolean;
};

export const FormSaveFooter: React.FC<FormSaveFooterProps> = ({ onSave, label, disabled }) => (
  <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2, mb: 1 }}>
    <SaveFormButton onClick={onSave} label={label} disabled={disabled} />
  </Box>
);
